<!-- 组件说明 -->
<template>
  <div class="distribution-list">
    <van-collapse
      v-model="activeNames"
      accordion
      :is-link="false"
      :class="distributionItem.ifExpired ? 'if_expired' : 'cb'"
    >
      <van-collapse-item :name="distributionIndex + 1">
        <template #title>
          <div class="infor">
            <span>{{ distributionIndex + 1 }}</span>
            <span class="person_name">{{ distributionItem.presentee }}</span>
            <span>
              <img
                src="~/common/images/recommend/sex_nan_select.png"
                v-if="!distributionItem.gender"
              />
              <img src="~/common/images/recommend/sex_nv_select.png" v-else />
            </span>
            <span>{{ distributionItem.contactNumber }}</span>
            <!-- 24小时以上就标红 -->
            <span
              :style="{
                color:
                  noDistributionTime / (1000 * 60 * 60) > 24
                    ? '#C82828'
                    : '#333333',
              }"
              >已提交{{ commitTime(noDistributionTime) }}</span
            >
          </div>
        </template>

        <div class="containt">
          <ul class="ul">
            <li class="li">
              <span>项目城市</span>
              <span class="adress">{{ distributionItem.orgName }}</span>
            </li>
            <li class="li">
              <span>推荐项目</span>
              <span class="adress">{{ distributionItem.projectName }}</span>
            </li>
            <li class="li">
              <span>推荐人</span>
              <span class="adress">{{ distributionItem.recUsername }}</span>
            </li>
            <li class="li">
              <span>推荐日期</span>
              <span class="adress">{{ distributionItem.createDate }}</span>
            </li>
            <li class="li">
              <span>推荐人电话</span>
              <span class="adress">{{ distributionItem.recUserMobile }}</span>
            </li>
            <li v-if="isShowDistribution">
              <Consultant
                v-if="!distributionItem.distributStatus"
                :projectCode="projectCode"
                @getCode="getCode"
              ></Consultant>
            </li>
          </ul>
          <div
            class="share"
            v-if="!distributionItem.distributStatus && isShowDistribution"
          >
            <div @click="distribution(distributionItem.id)">
              <img src="~/common/images/recommend/share.png" alt />
              <span>立即分配</span>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
import {
  Collapse as VanCollapse,
  CollapseItem as VanCollapseItem,
  Toast,
} from "vant";
import Consultant from "@/components/consultant";
export default {
  components: {
    VanCollapse,
    VanCollapseItem,
    Consultant,
    loading,
  },
  props: {
    noDistributionTime: Number,
    distributionItem: {
      type: Object,
    },
    distributionIndex: {
      type: Number,
    },
    projectCode: {
      type: String,
    },
    isShowDistribution: Boolean,
  },
  data() {
    return {
      activeNames: 1,
      consultant: "",
      loadingStatus: false,
    };
  },

  methods: {
    //提交时间
    commitTime(v) {
      let time = "",
        h = Math.floor(v / (1000 * 3600)),
        m = Math.floor((v % (1000 * 3600)) / (1000 * 60));
      time = (h >= 1 ? h + "h" : "") + (m >= 1 ? m + "m" : "1m");
      return time;
    },
    //分配
    distribution(id) {
      if (this.consultant) {
        let data = {
          id,
          adviserName: this.consultant.managerName,
          adviserCode: this.consultant.managerCode,
          adviserId: this.consultant.id,
        };
        this.loadingStatus = true;
        this.$api
          .distribute(data)
          .then(() => {
            Toast.success("分配成功");
            this.consultant = "";
            this.$bus.$emit("initRecommendNum");
            this.$emit("initList");
            this.loadingStatus = false;
          })
          .catch(() => {
            Toast.fail("分配失败");
            this.loadingStatus = false;
          });
      } else {
        Toast.fail("请选择置业顾问");
      }
    },

    //获取置业顾问信息
    getCode(v) {
      this.consultant = v;
    },
  },
};
</script>

<style lang="scss">
.distribution-list {
  margin-bottom: 30px;
  min-height: 120px;
  position: relative;
  .cb {
    background: rgba(238, 244, 242, 1);
    border-radius: 16px;
  }
  .van-collapse {
    width: 100%;
    box-shadow: 0px 2px 6px 0px rgba(164, 164, 164, 0.4);
    border-radius: 16px;
  }
  /deep/.van-collapse-item {
    .van-icon {
      align-self: center;
    }
    .van-cell {
      border-radius: 16px;
      background-color: inherit;
      padding: 0.2rem 0.32rem;
    }
  }
  .infor {
    display: flex;
    justify-content: space-between;
    color: #333333;
    line-height: 80px;
    height: 80px;
    font-weight: 500;
    margin-right: 60px;
    img {
      width: 80;
      height: 84px;
      padding: 10px;
    }
  }
  .containt {
    width: 100%;
    .ul {
      width: 100%;
      .li {
        width: 100%;
        display: flex;
        justify-content: space-between;
        height: 100px;
        border-bottom: 1px solid rgba(244, 245, 245, 1);
        line-height: 100px;
        font-family: PingFangSC-Regular, PingFang SC;
        .adress {
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    .share {
      height: 120px;
      text-align: center;
      line-height: 120px;
      img {
        width: 84px;
        height: 84px;
        padding: 15px;
      }
      span {
        color: rgba(13, 152, 105, 1);
      }
      .cb {
        border-radius: 16px;
      }
    }
  }
}
.distribution-list {
  position: relative;
  .van-cell {
    align-items: center;
  }
  .van-collapse-item .van-icon {
    display: none;
  }
  .infor {
    width: 100%;
    display: flex;
    justify-content: space-between;
    img {
      width: auto;
      height: 64px;
    }
  }
  .overdue {
    position: absolute;
    top: 0;
    left: 60;
    width: 88px;
    height: 80px;
    z-index: 1;
  }
}
</style>
